const callbacks = {};
let created = false;
function triggerFn(){
    for(let key in callbacks){
        callbacks[key] && callbacks[key]()
    }
}
export function insertCallback(id,fn, im){
    callbacks[id]=fn;
    if(im){
        fn()
    }
    if(!created){
        window.addEventListener("resize", triggerFn)
    }
}
export function removeCallback(id){
    delete callbacks[id];
    if(Object.keys(created).length === 0){
        window.removeEventListener("resize", triggerFn)
    }
}